import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';

class Deadline {
  id: number;
  status: number;
}

@Component({
  selector: 'app-deadline-dialog',
  templateUrl: './deadline-dialog.component.html',
  styleUrls: ['./deadline-dialog.component.scss']
})
export class DeadlineDialogComponent implements OnInit {
  /**
   * Title map
   */
  private readonly _titleMap: { [key: string]: string } = {
    '2': 'რეგისტრაციის თარიღი / პირველადი განხილვის ვადა',
    '3': 'ხმის მიცემის დაწყების თარიღი / ხმის მიცემის ვადა',
    '6': 'ხმის მიცემის დასრულების თარიღი / საბოლოო განხილვის ვადა',
    '11': 'დახარვეზების თარიღი / ხარვეზის გამოსწორების ვადა',
    '12': 'რედაქტირების თარიღი / გამოქვეყნების ვადა'
  };

  /**
   * Status to title map
   */
  private readonly _statusMap: { [key: string]: number[] } = {
    '6': [6, 8, 9, 13, 14, 16]
  };

  /**
   * Constructor
   *
   * @param data
   */
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}

  /**
   * Init
   */
  ngOnInit() {}

  /**
   * Returns deadline title by type
   *
   * @param deadline
   * @param defaultTitle
   */
  getDeadlineTitle(deadline: Deadline, defaultTitle: string = '') {
    const titleMapIndex = Object.keys(this._statusMap).find(
      (key) => this._statusMap[key].indexOf(deadline.status) >= 0
    );

    if (titleMapIndex) {
      return this._titleMap[titleMapIndex];
    } else if (this._titleMap[deadline.status]) {
      return this._titleMap[deadline.status];
    }

    return defaultTitle;
  }
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/components/deadline-dialog/deadline-dialog.component.ts